export default {"src":"/_next/static/image/public/images/flags/flag_218.df0fd2e6a7ef8f5be9f0a27aa71f5136.svg","height":16,"width":24};